export default __webpack_public_path__ + "static/media/67.655ae21a.jpg";